<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th style="width: 120px">Changed On</th>
          <th style="width: 180px">Changed By</th>
          <th style="width: 120px">Source</th>
          <th style="width: 120px">Merchant Number</th>
          <th style="width: 120px">Service Id</th>
          <th style="width: 120px">Service name</th>
          <th style="width: 120px">Value</th>
          <th style="width: 120px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let merchantParams of auditMerchantParamsViewModel">
          <td style="font-size: 12px">{{ merchantParams.id }}</td>
          <td style="font-size: 12px">
            {{ merchantParams.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ merchantParams.changedBy }}</td>
          <td style="font-size: 12px">{{ merchantParams.source }}</td>
          <td style="font-size: 12px">{{ merchantParams.merchantNumber }}</td>
          <td style="font-size: 12px">{{ merchantParams.serviceId }}</td>
          <td style="font-size: 12px">{{ merchantParams.serviceName }}</td>
          <td style="font-size: 12px">{{ merchantParams.value }}</td>
          <td style="font-size: 12px">{{ merchantParams.type }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
